import { useField } from "formik";
import { GenericField, InputProps } from "../Fields/GenericField";
import { TimeSelect } from "@/app/Offices/Components/OpenHoursInput";
import dayjs from "dayjs";

type TimePickerInputProps = InputProps & {
  onChange?: (val: string | null) => void;
};

export function TimePickerInput({ onChange, ...props }: TimePickerInputProps) {
  const [field, , helpers] = useField(props.name);
  const { setValue } = helpers;

  const displayValue = field.value
    ? dayjs(field.value, "HH:mm").format("h:mm A")
    : "--";

  return (
    <GenericField viewNode={<span>{displayValue}</span>} {...props}>
      <TimeSelect
        value={field.value}
        onSelect={async (value) => {
          await setValue(value);
          onChange?.(value);
        }}
        placeholder="Select time"
        className="w-full"
      />
    </GenericField>
  );
}
